<template>
	<div id="app">
		<transition name="transition-anim">
			<router-view class="view"/>
		</transition>

		<notification-banner v-if="bannerStatus"></notification-banner>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
import NotificationBanner from '@/components/utils/NotificationBanner.vue'
export default {
	computed: {
		...mapGetters('banner', {
			bannerStatus: 'getBannerStatus'
		})
	},

	mounted () {
		// testing @robert
		// this.$store.dispatch('banner/toggleBanner', {
		// 	status: true,
		// 	message: 'Testing of Notif (App.vue)',
		// 	type: 'success'
		// })
	},

	components: {
		NotificationBanner
	}
}
</script>
<style lang="scss">
#app {
	background-color: #F2F3F7;
	height: 100vh;

	.view {
		width: 100%;
		height: 100%;
		overflow: auto;
	}
}

*, *::after, *::before {
	box-sizing: border-box;
	margin: 0;
	padding: 0;
	outline: none;
	border: none;
	background: none;
}

* {
	-webkit-tap-highlight-color: transparent;

	&::-webkit-scrollbar {
		width: 10px;
		height: 10px;
	}

	&::-webkit-scrollbar-track { // track
		background : transparent;
	}

	&::-webkit-scrollbar-thumb { // thumb
		background-color: transparent;
		border-radius: 10px;
	}

	scrollbar-color: #ddd transparent;
	scrollbar-width: thin;

	&:hover {
		&::-webkit-scrollbar-thumb {
			background : #ddd;
		}
	}
}

html, body {
	font-family: sans-serif;
	color: #778395;
}

.container {
	max-width: 1366px;
	margin: 0 auto;
}

.icon {
	width: 1.2rem;
	height: 1.2rem;
	margin-right: .5rem;
}

form {
	padding: 4rem;
	background-color: #fff;
	border-radius: 0.15rem;
	display: flex;
	flex-direction: column;
	align-items: center;

	header {
		width: 100%;
		border-bottom: .05rem solid #D8DEEB;
		padding: .3rem 0;
		margin-bottom: 2rem;

		h3 {
			font-weight: 400;
		}

		p {
			margin-top: .5rem;
			font-size: .8rem;
		}
	}

	.flex-row {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		width: 100%;

		label {
			width: 100px;
		}

		> *:not(:last-child){
			margin-right: 1em;
		}

		&.control {
			justify-content: flex-end;
		}
	}
}

p {
	color: #B2C1D8;

	&.msg--error {
		padding: .5rem;
		color: #fff;
		background-color: #F4949A;
		width: 100%;
		margin-bottom: 1rem;
	}
}

button {
	border-radius: 0.15rem;
	padding: 0.5rem 1rem;
	cursor: pointer;
}

.button--ok {
	background-color: #EEF9F8;
	color: #18CDBC;
}

.button--cancel {
	background-color: #FFF4F4;
	color: #F4949A;
}

.button--edit {
	background-color: #F0F7FD;
	color: #3A9BEF;
}

a {
	text-decoration: none;
	color: inherit;
	cursor: pointer;
}

input, textarea {
	border: 0.05rem solid #D8DEEB;
	border-radius: 0.15rem;
}

#app {
	@include mobile {
		.container {
			max-width: 100%;
		}

		form {
			min-height: 80vh;
			width: 80vw;
			font-size: 1.5rem;

			label, input, button, p {
				font-size: 1em;
				margin: .5em 0;
			}

			input[type=radio] {
				margin: 0;
				padding: 0;
			}

			.flex-row, .radio-group {
				label:not(:last-child) {
					margin-right: .5em;
				}
			}

			input, button {
				padding: .5em;
			}

			button {
				width: 100%;
				text-align: center;
			}
		}

	}
}
</style>
